import { useAuth0 } from "@auth0/auth0-react";
import { Flex } from "@radix-ui/themes";
import { useGetMembers } from "@/api/member/Member.api";
import { useGetAccess } from "@/api/useAccess";
import { AddMembersDialog } from "./AddMembersDialog";
import { MembersList } from "./MembersList";
import styles from "./Members.module.scss";

export function Members() {
  const { user } = useAuth0();
  const { data: access } = useGetAccess(!!user);

  const { data, isLoading, refetch } = useGetMembers(!!user);

  return (
    <Flex direction={"column"} gap={"24px"}>
      <Flex justify={"between"} align={"start"}>
        <div className={styles.PageHeader}>
          <div className={styles.Title}>Team Members</div>
          <div className={styles.Description}>
            Manage your team members and their access to different features and spaces within your organization.
          </div>
        </div>
        {access.isAdmin && (
          <AddMembersDialog refetch={refetch}></AddMembersDialog>
        )}
      </Flex>

      <MembersList
        members={data ?? []}
        refetch={refetch}
        isAdmin={access.isAdmin}
        isLoading={isLoading}
      />
    </Flex>
  );
}
